<template>
  <v-card v-if="properties != null" flat>
    <CImage
      v-if="properties.image != null"
      :url="properties.image"
      :alt="properties.title"
      size="100px"
    ></CImage>
    <div class="centered pt-4" v-if="properties.title != null">
      <PrimaryTitle
        :title="properties.title"
        :variant_color="variant_color"
      ></PrimaryTitle>
    </div>
    <div class="centered" style="padding-top:20px">
      <span
        v-if="properties.subtitle"
        class="subsection-subtitle medium_grey--text"
        >{{ properties.subtitle }}</span
      >
    </div>
    <v-col :v-if="properties.children != null">
      <v-row v-for="(elem, id) in properties.children" :key="id" cols="12">
        <FactoryComponent :component="elem" :variant_color="variant_color" />
      </v-row>
    </v-col>
  </v-card>
</template>

<script>
import PrimaryTitle from "@/components/HomeSections/SubComponents/PrimaryTitle";
export default {
  name: "OneCol",
  props: {
    index: {
      type: Number,
      default: 0
    },
    properties: {
      type: Object,
      default: null
    },
    variant_color: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PrimaryTitle
  }
};
</script>
